import React, { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useLocation } from 'react-router';
import { PageNotFound } from '../../shop/PageNotFound';
import { CompleteCollectionPage } from './complete/CompleteCollectionPage';
import { CheckLoanFormat } from '../../shared/components/CheckLoanFormat';
import ReserveReportList from '../../shop/reserve/ReserveReportList';
import { ReserveDetail } from '../../shop/reserve/ReserveDetail';
import { ReserveCheckout } from '../../shop/reserve/ReserveCheckout';
import { ManageSubscriptionsPage } from '../../shop/subscriptions/ManageSubscriptionsPage';
import { ManageRenewalsPage } from '../../shop/renewals/ManageRenewalsPage';
import { YourCampaignsPage } from '../marketing/campaigns/YourCampaignsPage';
import { CAMPAIGN_PRODUCTS, useFeature } from '../../shared/utils/togglz';
import { CollectionSearchResultPage } from '../../shared/search/CollectionSearchResultPage';
import { ProductSelectionProvider } from '../../shared/product-selection/ProductSelectionContext';
import { useLoanFormat } from '../../app-store/loanFormat/useLoanFormat';
import { LOANFORMAT_ALL_OBJECT, LOANFORMAT_EPRESS_OBJECT } from '../../shared/loanFormat/constants';

const CollectionManagementRouteSwitch: FC = () => {
    const isCampaignsEnabled = useFeature(CAMPAIGN_PRODUCTS);
    const { search } = useLocation();
    const {
        loanFormat: { urlKey: currentLoanFormat }
    } = useLoanFormat();

    return (
        <Routes>
            <Route index element={<Navigate to={{ pathname: 'collection', search }} replace />} />

            <Route path="collection">
                <Route index element={<Navigate to={{ pathname: currentLoanFormat, search }} replace />} />
                <Route
                    path=":loanFormat"
                    element={
                        <CheckLoanFormat>
                            <ProductSelectionProvider>
                                <CompleteCollectionPage />
                            </ProductSelectionProvider>
                        </CheckLoanFormat>
                    }
                />
            </Route>

            <Route path="reserves">
                <Route index element={<ReserveReportList />} />
                <Route path=":reserveListId">
                    <Route index element={<ReserveDetail />} />
                    <Route path="checkout" element={<ReserveCheckout />} />
                </Route>
            </Route>

            <Route path="campaigns">
                <Route
                    index
                    element={
                        isCampaignsEnabled ? (
                            <Navigate
                                to={{
                                    pathname:
                                        currentLoanFormat === LOANFORMAT_EPRESS_OBJECT.urlKey
                                            ? LOANFORMAT_ALL_OBJECT.urlKey
                                            : currentLoanFormat,
                                    search
                                }}
                                replace
                            />
                        ) : (
                            <Navigate to=".." replace />
                        )
                    }
                />
                <Route
                    path=":loanFormat"
                    element={
                        isCampaignsEnabled ? (
                            <CheckLoanFormat>
                                <YourCampaignsPage />
                            </CheckLoanFormat>
                        ) : (
                            <Navigate to=".." replace />
                        )
                    }
                />
            </Route>

            <Route path="subscriptions">
                <Route index element={<ManageSubscriptionsPage />} />
                <Route path="renewals" element={<ManageRenewalsPage />} />
            </Route>

            <Route
                path="search/:loanFormat"
                element={
                    <CheckLoanFormat>
                        <ProductSelectionProvider>
                            <CollectionSearchResultPage />
                        </ProductSelectionProvider>
                    </CheckLoanFormat>
                }
            />

            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
};

export default CollectionManagementRouteSwitch;
